import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function Casely(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <path
          d="M107 36.9271C103.145 36.9271 99.2792 36.9374 95.424 36.9374C84.7001 36.9374
          73.9658 36.9374 63.2419 36.9374C63.0237 36.9374 62.7951 36.9374 62.5353
          36.9374C62.5353 36.5878 62.5353 36.2692 62.5353 35.8991C76.9897 35.8991 91.4233
          35.8991 105.899 35.8991C105.899 24.2822 105.899 12.7168 105.899 1.11028C70.9731
          1.11028 36.0373 1.11028 1.05992 1.11028C1.05992 12.6757 1.05992 24.2514 1.05992
          35.8682C15.4104 35.8682 29.7401 35.8682 44.1218 35.8682C44.1218 36.228 44.1218
          36.5467 44.1218 36.8963C29.4284 36.8963 14.735 36.8963 0 36.8963C0 24.6215 0
          12.3467 0 0C35.6632 0 71.3368 0 107 0C107 12.3056 107 24.6112 107 36.9271Z"
          fill="currentColor"
        />
        <path
          d="M53.5364 43.9999C52.8713 43.3523 52.2167 42.7046 51.4789 41.985C52.8609 41.985
          54.1495 41.985 55.5003 41.985C54.8665 42.6635 54.2534 43.3317 53.6403 43.9999C53.5987
          43.9999 53.5676 43.9999 53.5364 43.9999Z"
          fill="currentColor"
        />
        <path
          d="M61.1221 36.485C59.553 37.9551 57.9423 39.4663 56.3628 40.9672C56.3524 40.8747
          56.3317 40.6896 56.3213 40.5046C54.4612 40.5046 52.6115 40.5046 50.7619
          40.5046C50.7515 40.7308 50.7411 40.9158 50.7307 41.07C49.172 39.5074
          47.6029 37.9345 46.0026 36.3205C47.5198 34.9018 49.1408 33.3906 50.7723
          31.8691C50.7307 31.8177 50.6891 31.756 50.6476 31.7046C50.6891 31.828
          50.7307 31.941 50.7723 32.0644C50.8034 32.0747 50.8346 32.0952 50.8658
          32.0952C52.5596 32.0952 54.2534 32.0952 55.9472 32.0747C56.1134 32.0747
          56.2797 31.8999 56.4771 31.7971C57.9215 33.2672 59.4699 34.8298 61.1221
          36.485ZM56.3005 32.3934C54.3989 32.3934 52.57 32.3934 50.7515 32.3934C50.7515
          35.0252 50.7515 37.6055 50.7515 40.1653C52.6427 40.1653 54.4612 40.1653 56.3005
          40.1653C56.3005 37.5541 56.3005 34.984 56.3005 32.3934Z"
          fill="currentColor"
        />
        <path
          d="M59.6569 18.6075C59.6569 16.6028 59.6569 14.6084 59.6569 12.6037C59.6569 11.9664
          59.8128 11.8019 60.4362 11.8019C63.0964 11.8019 65.767 11.8019 68.4272 11.8019C68.8221
          11.8019 69.1546 11.9252 69.1546 12.3467C69.1546 12.7682 68.7805 12.8094 68.4376
          12.8094C66.0164 12.8094 63.5952 12.8196 61.174 12.7991C60.748 12.7991 60.6441 12.9327
          60.6441 13.3234C60.6649 14.7421 60.6649 16.1608 60.6441 17.5794C60.6337 18.0112 60.8103
          18.0832 61.1948 18.0832C62.7639 18.0626 64.3434 18.0729 65.9125 18.0729C66.0788 18.0729
          66.297 18.0421 66.4113 18.1243C66.5775 18.2477 66.775 18.4636 66.775 18.6383C66.775
          18.772 66.5152 18.9467 66.3489 19.0393C66.245 19.1009 66.0788 19.0598 65.9437
          19.0598C64.385 19.0598 62.8263 19.0598 61.2779 19.0598C60.7376 19.0598 60.5921
          19.2346 60.6025 19.7794C60.6129 21.1056 60.6233 22.4421 60.6129 23.7682C60.6129
          24.2514 60.748 24.3953 61.3195 24.3953C63.6056 24.3851 65.8813 24.3645 68.1674
          24.3439C68.3753 24.3439 68.6143 24.3131 68.7805 24.3953C68.9364 24.4776 69.1027
          24.7037 69.0923 24.8579C69.0819 25.0122 68.8844 25.1766 68.7286 25.3C68.6662
          25.3514 68.5311 25.3103 68.4272 25.3103C65.767 25.3103 63.0964 25.3103 60.4362
          25.3103C59.74 25.3103 59.6673 25.2383 59.6673 24.5393C59.6569 22.5757 59.6569
          20.5916 59.6569 18.6075Z"
          fill="currentColor"
        />
        <path
          d="M36.3594 25.3308C36.2659 25.228 36.0685 25.0738 35.9645 24.8682C35.632 24.1794 35.3203
          23.4701 35.0397 22.7608C34.8838 22.3804 34.6552 22.2056 34.2292 22.2159C32.047 22.2262
          29.8752 22.2365 27.693 22.2159C27.2462 22.2159 26.9968 22.3598 26.8305 22.771C26.55
          23.4907 26.2382 24.1897 25.8953 24.8785C25.8018 25.0738 25.5524 25.2794 25.3446
          25.3206C25.0016 25.3925 24.825 25.1664 24.9185 24.8168C24.9601 24.6729 25.0328 24.529
          25.0952 24.3953C26.8201 20.4888 28.5451 16.572 30.2701 12.6654C30.2805 12.6449 30.2805
          12.6346 30.2909 12.614C30.4987 12.3673 30.6753 11.9664 30.9351 11.915C31.3923 11.8122
          31.4651 12.3159 31.6002 12.6243C33.3563 16.5925 35.0917 20.571 36.8374 24.5495C37.066
          25.0841 36.9621 25.3308 36.3594 25.3308ZM34.3747 21.229C33.2108 18.6178 32.099 16.0991
          30.9351 13.4879C29.7817 16.1094 28.6594 18.6383 27.5164 21.229C29.8336 21.229 32.0158
          21.229 34.3747 21.229Z"
          fill="currentColor"
        />
        <path
          d="M47.686 25.3412C45.9714 25.3618 44.5374 24.8683 43.4879 23.5421C43.0723 23.0178 42.8021
          22.4319 42.8436 21.7534C42.854 21.5786 43.0619 21.2702 43.1554 21.2805C43.3632 21.301 43.6438
          21.4347 43.7477 21.6094C43.9243 21.887 43.9555 22.2571 44.101 22.5655C44.6102 23.6552 45.5038
          24.2104 46.6885 24.3235C48.0185 24.4571 49.3071 24.3749 50.4086 23.4907C50.5956 23.3468 50.7723
          23.172 50.9074 22.9767C51.375 22.2879 51.614 21.1365 50.4917 20.4786C49.6396 19.9749 48.7148
          19.5945 47.8107 19.173C46.7612 18.6795 45.6805 18.2272 44.6517 17.6823C43.9659 17.3225 43.4567
          16.7571 43.2593 15.9758C43.0411 15.102 43.3009 14.3206 43.81 13.6113C45.5558 11.2057 49.6396
          11.2263 51.3126 13.673C51.6348 14.1459 51.7698 14.7627 51.9465 15.3281C52.04 15.6468 51.8841
          15.9141 51.5308 15.9655C51.1775 16.0169 50.9697 15.801 50.9593 15.4618C50.9074 13.9506 49.5773
          12.9842 47.9562 12.8403C46.9482 12.7478 46.0026 12.9431 45.1817 13.5805C43.7685 14.6702 43.8516
          16.2122 45.4311 17.0244C46.5118 17.5795 47.6756 17.9805 48.7771 18.4945C49.5876 18.8749
          50.4086 19.2552 51.136 19.7487C52.4972 20.6842 52.7051 22.2674 51.6659 23.5421C50.6372 24.7963
          49.2759 25.4029 47.686 25.3412Z"
          fill="currentColor"
        />
        <path
          d="M9.05088 18.5458C9.04049 20.1598 9.51849 21.4552 10.4122 22.586C12.4073 25.1253 15.9715 24.9916
          17.9043 22.3084C18.0394 22.1131 18.1953 21.8972 18.3927 21.8047C18.5486 21.7327 18.8396 21.7533 18.985
          21.8561C19.0786 21.9281 19.0786 22.257 18.9954 22.3907C18.1329 23.7991 16.9483 24.8374
          15.2753 25.2075C12.9476 25.7215 11.0772 24.9402 9.61202 23.1206C7.42983 20.4066 7.64805
          16.2944 9.78867 13.8477C12.3346 10.9383 16.4911 11.1748 18.6733 14.3925C18.7564 14.5159 18.8811
          14.6393 18.9123 14.7832C18.9643 14.9785 18.9435 15.1841 18.9539 15.3795C18.7149 15.3795 18.4655
          15.4 18.2265 15.3589C18.1226 15.3383 18.0394 15.1738 17.9667 15.0608C16.9172 13.4981 15.4624
          12.6449 13.5503 12.8299C11.6591 13.015 10.4329 14.1458 9.68476 15.8318C9.27949 16.757 9.0301
          17.7028 9.05088 18.5458Z"
          fill="currentColor"
        />
        <path
          d="M92.795 21.9692C92.795 21.2187 92.7638 20.4683 92.8054 19.7178C92.8469 19.0393 92.6287
          18.4944 92.2027 17.9804C90.7791 16.2327 89.3762 14.4851 87.9734 12.7271C87.7863 12.4907
          87.3707 12.244 87.7448 11.8636C87.9422 11.658 88.5241 11.8533 88.7839 12.1823C90.1556
          13.8991 91.5169 15.6159 92.8885 17.3327C93.2522 17.7954 93.3146 17.7954 93.6886
          17.3225C94.946 15.7187 96.2034 14.1047 97.4711 12.501C97.6478 12.2748 97.8452 12.0178
          98.0842 11.9047C98.2712 11.8122 98.5518 11.915 98.7908 11.9253C98.7493 12.1412 98.77
          12.3982 98.6557 12.5626C98.2089 13.1898 97.7205 13.786 97.2321 14.3926C96.3385
          15.5028 95.4448 16.6131 94.5407 17.7028C93.8861 18.4841 93.6783 19.3271 93.751
          20.3552C93.8549 21.8561 93.803 23.357 93.803 24.858C93.803 25.1767 93.6159 25.3514
          93.273 25.3412C92.8989 25.3309 92.8054 25.0944 92.795 24.7963C92.7846 23.8505 92.795
          22.915 92.795 21.9692Z"
          fill="currentColor"
        />
        <path
          d="M75.961 18.5562C75.961 16.6235 75.961 14.6908 75.961 12.7683C75.961 12.5936 75.909 12.388
          75.9921 12.2646C76.1064 12.0898 76.3143 11.8637 76.4909 11.8534C76.6572 11.8431 76.8754
          12.059 76.9897 12.2338C77.0832 12.3777 77.0624 12.5936 77.0624 12.7786C77.0624 15.7908
          77.0521 18.7926 77.0417 21.8048C77.0417 22.4524 77.0105 23.1001 77.0001 23.7478C76.9897
          24.2104 77.1975 24.4263 77.6963 24.416C79.5668 24.3954 81.4268 24.4057 83.2973
          24.3954C83.661 24.3954 83.9623 24.3954 83.9623 24.8683C83.9727 25.3309 83.6714 25.3309
          83.3389 25.3309C81.1255 25.3309 78.9121 25.3309 76.6987 25.3309C76.096 25.3309 75.9817
          25.2179 75.9817 24.6113C75.961 22.5964 75.961 20.5814 75.961 18.5562Z"
          fill="currentColor"
        />
        <path
          d="M51.6451 30.6458C52.3102 30.0496 52.9337 29.4841 53.5779 28.9084C54.0663 29.4122 54.6586
          30.029 55.251 30.6458C54.0975 30.6458 52.9025 30.6458 51.6451 30.6458Z"
          fill="currentColor"
        />
        <path
          d="M52.0088 31.4684C51.7906 31.6226 51.6659 31.7871 51.5516 31.7665C51.4373 31.7562 51.2918
          31.5815 51.2607 31.4581C51.2399 31.3861 51.4269 31.1908 51.5308 31.1908C51.6555 31.1908
          51.7802 31.3244 52.0088 31.4684Z"
          fill="currentColor"
        />
        <path
          d="M56.3005 32.3933C56.3005 34.984 56.3005 37.5643 56.3005 40.1653C54.4716 40.1653 52.6427
          40.1653 50.7515 40.1653C50.7515 37.6055 50.7515 35.0251 50.7515 32.3933C52.57 32.3933
          54.3989 32.3933 56.3005 32.3933Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
}
